import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { HistoryData } from '../../providers/history-data';
import { ParkbewilligungenData, PbActions } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import moment from 'moment';

/**
 * Generated class for the PbcatrulesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'history',
  templateUrl: 'history.html'
})
export class HistoryComponent {
  private _record_id;
  @Input('record_id') 
  get record_id(): number {
    return this._record_id;
  }
  set record_id(value: number) {
    this._record_id = value;    
    this.loadData();
  }    

  private _table;
  @Input('table') 
  get table(): string {
    return this._table;
  }
  set table(value: string) {
    this._table = value;
    this.loadData();
  }    

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  private data;

  constructor(
    public userData: UserData
    ,public historyData: HistoryData
    , public pbData: ParkbewilligungenData
  ) 
  {
      this.data = [];
      this._table = "";
      this._table = "";
  }

  loadData(){

    if(this._record_id && this._table && this._table != ""){        
      this.historyData.load(this._table, this._record_id).then(res => {     
        this.data = res;   
        //console.log(res);
        //this.oSelectedKategorieRegeln = res;
      });    

      

    }

  }
  
}



// WEBPACK FOOTER //
// ./src/components/history/history.ts